module.exports = __webpack_public_path__ + "static/media/sign-up.6774df14.jpg";